import { Component, Input, OnInit } from "@angular/core"
import { WindowSizeService } from "../../../services/window-size.service"
import { AddOnViewService } from "../../../services/add-on-view.service"
import { Resource } from "../../../models/resource/resource"
import { routeAnimations, routeTransition } from "../../../utils/animations"

@Component({
    selector: "app-image-resource",
    templateUrl: "./image-resource.component.html",
    styleUrls: ["./image-resource.component.scss"],
    host: { "[@routeTransition]": "true", "[@routeAnimations]": "false", style: "display: block;" },
    animations: [routeTransition, routeAnimations],
    standalone: false,
})
export class ImageResourceComponent implements OnInit {
    @Input() resource: Resource
    isAddonView: boolean

    constructor(
        public windowSize: WindowSizeService,
        public addOnService: AddOnViewService
    ) {}

    ngOnInit() {
        this.isAddonView = this.addOnService.isAddonView
    }
}
